import { getCameraId } from "../../../../shared/utils/utils";
import { getAzureBlob } from "../../../../services/container";

export const getImageUrlFromHistory = (history) =>
  history?.image_url ||
  (Array.isArray(history?.image_urls) && history.image_urls.length > 0
    ? history.image_urls[0]
    : "");

export const parseCharacterizationComments = (commentsString) => {
  if (!commentsString) return [];
  try {
    const parsed = JSON.parse(commentsString);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const buildCharacterizationCommentsBlobInfo = ({
  cameraId,
  timeStamp,
  containerId,
}) => {
  const normalizedTimeStamp = timeStamp.replace(/:/g, "_").slice(0, -1);
  const blobName = `camera-ak_${cameraId}/output-client/${normalizedTimeStamp}-camera-ak_${cameraId}-${containerId}-client.json`;
  const azureUrl = process.env.REACT_APP_AZURE_URL || "";
  const blobUrl = `${azureUrl}${blobName}`;
  return { blobName, blobUrl };
};

export const loadCharacterizationComments = async ({
  container,
  superContainer,
  historyMaterial,
  historyId = 0,
}) => {
  if (!container?._id || !historyMaterial || historyMaterial.length === 0) {
    return [];
  }

  const targetHistory = historyMaterial[historyId] || historyMaterial[0];
  const timeStamp =
    targetHistory?._time ||
    new Date().toISOString().replace(/:/g, "_").slice(0, -1);
  const imageUrl =
    getImageUrlFromHistory(targetHistory) || container?.image_url || "";
  const cameraId = getCameraId(imageUrl);

  if (!cameraId || !timeStamp) {
    return [];
  }

  const containerId = superContainer?._id || container._id;
  const { blobUrl } = buildCharacterizationCommentsBlobInfo({
    cameraId,
    timeStamp,
    containerId,
  });

  try {
    const azureResponse = await getAzureBlob({ blobUrl });
    const existing = azureResponse.data || {};
    return parseCharacterizationComments(existing.comments);
  } catch {
    return [];
  }
};

export const getCommentAuthorName = (author = {}) =>
  author.name ||
  `${author.firstName || ""} ${author.lastName || ""}`.trim() ||
  "";
